import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Typography,
  Box,
  Button,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,
  TextField,
  Paper,
  Grid,
  Pagination,
  Skeleton,
  Popover,
} from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "../../assets/images/closeIcon.png";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import GroupIcon from "@mui/icons-material/Group";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Background,
  Controls,
  Node,
  Edge,
  Connection,
  BackgroundVariant,
  MarkerType,
} from "reactflow";
import dagre from "dagre";
import "reactflow/dist/style.css";
import "./OrgPage.scss";
import { useNavigate, useParams } from "react-router-dom";
import AddNoteDialog from "../AddNotes";
import AddStakeHolderDialog from "../AddStakeHolder";
import StakeHoldersDetail from "../StakeHoldersDetail";
import {
  GetStakeList,
  DeleteStake,
  GetStakeDetail,
  UpdateGraphList,
} from "../../service/StakeService";
import { GetStakemapDetail } from "../../service/StakemapService";
import { PreferencesContext } from "../../PreferenceContext";
import { AlertType } from "../../shared/AlertType";
import StakeholderNode from "./StakeholderNode";
import Editicon from "../../assets/images/editicon.png";
import Detailicon from "../../assets/images/detailicon.png";
import NoteIcon from "../../assets/images/note.png";
import editProfileIcon from "../../assets/images/editprofile.png";
import { reconnectEdge } from "reactflow";
import zoomIcon from "../../assets/images/zoomIcon.png";
import moreIcon from "../../assets/images/moreIcon.png";
import CustomPagination from "../CustomPagination";
import DuplicateIcon from "../../assets/images/duplicateIcon.png";
import DeleteImage from "../../assets/images/deleteIcon.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditStakeIcon from "../../assets/images/editStakeIcon.png";
import {
  GetStakeRelationList,
  handleUpdateEdge,
  handleUpdateStakeRelation,
} from "../../service/StakeRelationService";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CustomDeletableEdge from "./CustomDeletableEdge.tsx";

const OrgPage = ({
  title,
  setTitle,
  handleSave,
}: {
  title: string;
  setTitle: (val: string) => void;
  handleSave: () => void;
}) => {
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  // const [title, setTitle] = useState("Untitled Stake");
  const navigate = useNavigate();
  const [stakeList, setStakeList] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedStakeholder, setSelectedStakeholder] = useState<any>(null);
  // const { token } = useParams();
  // const token = userContext?.token;
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const urlToken = tokenFromParams;
  const isOwner = !urlToken || urlToken === userContext?.localToken;

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteStakeId, setDeleteStakeId] = useState<any>(null);
  const [addNotesPopup, setAddNotesPopup] = useState<any>({
    open: false,
    stakeId: null,
  });
  const [addStackHolderPopup, setAddStackHolderPopup] = useState<any>({
    open: false,
    stakeId: null,
    uid: null,
  });
  const [historyAndDetailsPopup, setHistoryAndDetailsPopup] = useState<any>({
    open: false,
    stake: null,
  });

  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [param, setParam] = useState({
    pageIndex: 1,
    pageSize: 10,
    sortBy: "",
  });
  interface Stake {
    UID: number;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    PARENT_STAKE_ID?: number | null;
    IS_GRAPH?: boolean;
    PROFILE_IMAGE_BASE64?: string;
    // Add more fields if needed
  }
  const flowRef = useRef<HTMLDivElement>(null);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  const [selectedEdge, setSelectedEdge] = useState<Edge | null>(null);
  const [openEdgeDeletePopover, setOpenEdgeDeletePopover] = useState(false);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const edgeTypes = {
    deletable: CustomDeletableEdge,
  };

  const edgeReconnectSuccessful = useRef(true);
  const nodeWidth = 270;
  const nodeHeight = 80;
  const getLayoutedElements = (nodes: Node[], edges: Edge[]) => {
    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));

    dagreGraph.setGraph({
      rankdir: "TB", // Top to Bottom layout
      nodesep: 105, // horizontal gap between nodes
      ranksep: 120, // vertical gap between nodes
    });

    nodes.forEach((node) => {
      dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
    });

    edges.forEach((edge) => {
      dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    const layoutedNodes = nodes.map((node) => {
      const nodeWithPosition = dagreGraph.node(node.id);
      node.position = {
        x: nodeWithPosition.x - nodeWidth / 2,
        y: nodeWithPosition.y - nodeHeight / 2,
      };
      return node;
    });

    return { nodes: layoutedNodes, edges };
  };
  const onReconnectStart = useCallback(() => {
    edgeReconnectSuccessful.current = false;
  }, []);

  const onReconnect = useCallback(
    (oldEdge: Edge, newConnection: Connection) => {
      edgeReconnectSuccessful.current = true;
      setEdges((eds) => reconnectEdge(oldEdge, newConnection, eds));
    },
    [setEdges]
  );

  const onEdgeDelete = useCallback(
    async (edge: Edge) => {
      // 1. Remove edge from state
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));

      // 2. Update child node's PARENT_STAKE_ID locally
      setNodes((nds) =>
        nds.map((node) => {
          if (node.id === edge.target) {
            return {
              ...node,
              data: { ...node.data, PARENT_STAKE_ID: 0 },
            };
          }
          return node;
        })
      );

      // 3. Update backend
      try {
        const childUID = Number(edge.target.split("-")[0]); // ya node.data.UID agar available ho
        // await handleUpdateParentStackId(childUID, 0);
      } catch (err) {
        console.error("Failed to update parent:", err);
      }
    },
    [setEdges, setNodes]
  );
  const onEdgesDelete = useCallback(
    async (deletedEdges: Edge[]) => {
      // Remove edges from state
      setEdges((eds) =>
        eds.filter((e) => !deletedEdges.some((d) => d.id === e.id))
      );

      // Update parent_stake_id for each affected node
      const updatedNodes = await Promise.all(
        nodes.map(async (node) => {
          const deletedEdge = deletedEdges.find((e) => e.target === node.id);
          if (deletedEdge) {
            const relationUID = Number(deletedEdge.id.split("-")[1]);
            // Call your API to set PARENT_STAKE_ID = 0
            await handleUpdateEdge(Number(relationUID));

            return {
              ...node,
              data: { ...node.data, PARENT_STAKE_ID: 0 },
            };
          }
          return node;
        })
      );

      setNodes(updatedNodes);
    },
    [nodes, setEdges, setNodes, userContext]
  );

  const handleEdgeContextDelete = (edge: Edge) => {
    // Remove edge from state
    setEdges((eds) => eds.filter((e) => e.id !== edge.id));

    // Update the child node's parent to 0
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === edge.target) {
          return {
            ...node,
            data: { ...node.data, PARENT_STAKE_ID: 0 },
          };
        }
        return node;
      })
    );

    // Call backend to update parent
    const childUID = Number(edge.target.split("-")[0]); // ya node.data.UID
    // handleUpdateParentStackId(childUID, 0);
  };
  const handleEdgeContextMenu = (event: React.MouseEvent, edge: Edge) => {
    event.preventDefault(); // default context menu ko roko
    setSelectedEdge(edge);

    // Use mouse coordinates
    setPopoverAnchorEl({
      getBoundingClientRect: () => ({
        top: event.clientY,
        left: event.clientX,
        right: event.clientX,
        bottom: event.clientY,
        width: 0,
        height: 0,
        x: event.clientX,
        y: event.clientY,
        toJSON: () => {},
      }),
    } as any);

    setOpenEdgeDeletePopover(true);
  };

  // Reconnect end: remove old edge if reconnect failed
  const onReconnectEnd = useCallback(
    (_: MouseEvent | TouchEvent, edge: Edge) => {
      if (!edgeReconnectSuccessful.current) {
        onEdgeDelete(edge); // call our fixed onEdgeDelete
      }
      edgeReconnectSuccessful.current = true;
    },
    [onEdgeDelete]
  );
  const nodeTypes = useMemo(() => ({ stakeholder: StakeholderNode }), []);

  const handleConnectOnDrop = (sourceUID: number, targetUID: number) => {
    const tryConnect = (retries = 0) => {
      setNodes((currentNodes) => {
        const sourceNode = currentNodes.find((n) => n.data.UID === sourceUID);
        const targetNode = currentNodes.find((n) => n.data.UID === targetUID);

        if (sourceNode && targetNode) {
          setEdges((eds) => {
            const alreadyExists = eds.some(
              (e) => e.source === sourceNode.id && e.target === targetNode.id
            );
            if (!alreadyExists) {
              return addEdge(
                {
                  id: `e-${sourceNode.id}-${targetNode.id}`,
                  source: sourceNode.id,
                  target: targetNode.id,
                  type: "default",
                },
                eds
              );
            }
            return eds;
          });
        } else {
          if (retries < 10) {
            setTimeout(() => tryConnect(retries + 1), 100);
          } else {
            console.warn(
              "⚠️ Connection failed after retries:",
              sourceUID,
              targetUID
            );
          }
        }

        return currentNodes;
      });
    };

    tryConnect();
  };

  const onDrop = useCallback(
    async (event: React.DragEvent) => {
      event.preventDefault();
      if (!flowRef.current) return;

      const reactFlowBounds = flowRef.current.getBoundingClientRect();
      const data = event.dataTransfer.getData("application/stakeholder");
      if (!data) return;

      const stakeholder: any = JSON.parse(data);
      const rawX = event.clientX - reactFlowBounds.left;
      const rawY = event.clientY - reactFlowBounds.top;

      const snappedX = Math.round(rawX / 200) * 200;
      const snappedY = Math.round(rawY / 100) * 100;

      const id = `${stakeholder.id}-${Date.now()}`;

      try {
        const response: any = await GetStakeDetail({ UID: stakeholder.id });
        const stake = response.data.data;

        await updateGraphList(stake.UID, true);

        const newNode: Node = {
          id,
          type: "stakeholder",
          position: { x: snappedX, y: snappedY },
          data: {
            UID: stake.UID,
            PARENT_STAKE_ID: 0,
            refreshStakeList: fetchStakList,
          },
        };

        const updatedNodes = [...nodes, newNode];
        const { nodes: layoutedNodes, edges: layoutedEdges } =
          getLayoutedElements(updatedNodes, edges);

        setNodes(layoutedNodes);
        setEdges(edges);
      } catch (err) {
        console.error("Drop failed:", err);
      }
    },
    [nodes, edges, setNodes, setEdges]
  );
  const handleManualConnect = useCallback(
    async (params: Connection) => {
      if (params.source === params.target) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Cannot connect a node to itself.",
          alertType: AlertType.Error,
        });
        return;
      }

      const targetNode = nodes.find((n) => n.id === params.target);

      if (!targetNode) return;

      const currentParent = Number(targetNode?.data?.PARENT_STAKE_ID);
      // const hasParent = currentParent !== 0 && !isNaN(currentParent);

      // if (hasParent) {
      //   updateUserContext({
      //     ...userContext,
      //     isAlert: true,
      //     alertMessage: "This node already has a parent.",
      //     alertType: AlertType.Error,
      //   });
      //   return;
      // }
      let currentNode = nodes.find((n) => n.id === params.source);
      while (currentNode && currentNode.data?.PARENT_STAKE_ID) {
        const parentId = String(currentNode.data.PARENT_STAKE_ID);
        if (parentId === params.target) {
          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage:
              "Invalid connection: cannot connect a child to its parent.",
            alertType: AlertType.Error,
          });
          return;
        }
        currentNode = nodes.find((n) => n.id === parentId);
      }
      const newEdge: Edge = {
        id: `e-${params.source}-${params.target}`,
        source: params.source!,
        target: params.target!,
        type: "deletable",
        markerEnd: { type: MarkerType.ArrowClosed },
        data: {
          relationUID: `${params.source}-${params.target}`,
          onDeleteEdge: onEdgesDelete,
        },
      };

      setEdges((eds) => addEdge(newEdge, eds));

      const stakeUID = Number(params.target?.split("-")[0]);
      const parentStakeUID = Number(params.source?.split("-")[0]);

      await handleUpdateStakeRelation(
        stakeUID,
        parentStakeUID,
        userContext?.UID
      );

      const updatedNodes = nodes.map((node) => {
        if (node.id === params.target) {
          return {
            ...node,
            data: {
              ...node.data,
              PARENT_STAKE_ID: parentStakeUID,
            },
          };
        }
        return node;
      });

      const { nodes: layoutedNodes, edges: layoutedEdges } =
        getLayoutedElements(updatedNodes, [...edges, newEdge]);
      setNodes(layoutedNodes);
      setEdges(layoutedEdges);
    },
    [nodes, edges, updateUserContext, userContext]
  );

  const onDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const handleOpenAddNotesPopup = (stakeId: any) => {
    setAddNotesPopup({ open: true, stakeId });
  };
  const handleOpenEditStackHolderPopup = (uid: any) => {
    if (totalCount >= 5 && userContext?.userId === 0) {
      navigate("/sign-up");
    } else {
      setAddStackHolderPopup({ open: true, uid });
    }
  };
  const closeAddStakeHolderPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      fetchStakList();
    }
    setAddStackHolderPopup({ open: false, uid: null });
  };

  const handleOpenHistoryAndDetailsPopup = (stake: any) => {
    setHistoryAndDetailsPopup({ open: true, stake });
  };

  const closeHistoryAndDetailsPopup = () => {
    setHistoryAndDetailsPopup({ open: false, stake: null });
    fetchStakList();
  };
  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    stake: any
  ) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedStakeholder(stake);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedStakeholder(null);
  };

  const handleDeleteStake = (UID: any) => {
    setDeleteStakeId(UID);
    setOpenDeleteModal(true);
  };
  const filteredStakeList = stakeList.filter(
    (stake) => !nodes.some((node) => node.data.UID === stake.UID)
  );

  // With this:
  const staleholdersList = useMemo(() => {
    const start = (param.pageIndex - 1) * param.pageSize;
    const end = start + param.pageSize;
    return filteredStakeList.slice(start, end);
  }, [filteredStakeList, param.pageIndex, param.pageSize]);

  const handleConfirmDeleteStake = async () => {
    try {
      await DeleteStake(deleteStakeId);

      // updateUserContext({
      //   ...userContext,
      //   isAlert: true,
      //   alertMessage: "Stakeholder deleted successfully.",
      //   alertType: AlertType.Success,
      // });

      setOpenDeleteModal(false);
      setDeleteStakeId(null);

      if (historyAndDetailsPopup.open) closeHistoryAndDetailsPopup();

      fetchStakList();
    } catch (error: any) {
      console.error("Error deleting stakeholder:", error);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error?.message || "Something went wrong!",
        alertType: AlertType.Error,
      });
    }
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteStakeId(null);
  };

  // const fetchStakList = async (
  //   sortBy: string = "",
  //   pageIndex: number = 1,
  //   pageSize: number = 10
  // ) => {
  //   setLoading(true);
  //   try {
  //     let response: any;
  //     let params = new URLSearchParams();
  //     params.append("token", token || "");
  //     params.append("SORT_BY", sortBy);
  //     // params.append("pageIndex", pageIndex.toString());
  //     // params.append("pageSize", pageSize.toString());
  //     params.append("pageSize", "all"); // or just omit pageSize and offset
  //     params.append("pageIndex", "1");
  //     response = await GetStakeList(params);
  //     if (response?.data?.data?.stakeColl) {
  //       const list: Stake[] = response.data?.data?.stakeColl || [];

  //       setStakeList(list);
  //       setTotalCount(response.data.data.total_data_count || 0);

  //       const newNodes: Node[] = list
  //         .filter(
  //           (stake) => stake.IS_GRAPH === true
  //           // stake.PARENT_STAKE_ID !== null ||
  //           // list.some((child) => child.PARENT_STAKE_ID === stake.UID)
  //         )
  //         .map((stake) => ({
  //           id: String(stake.UID),
  //           type: "stakeholder",
  //           position: { x: Math.random() * 400, y: Math.random() * 400 },
  //           data: {
  //             UID: stake.UID,
  //             // PARENT_STAKE_ID: stake.PARENT_STAKE_ID,
  //             refreshStakeList: fetchStakList,
  //           },
  //         }));
  //     }
  //   } catch (error: any) {
  //     updateUserContext({
  //       ...userContext,
  //       isAlert: true,
  //       alertMessage: error.message,
  //       alertType: AlertType.Error,
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchStakList = async (
    sortBy: string = "",
    pageIndex: number = 1,
    pageSize: number = 10
  ) => {
    setLoading(true);
    try {
      let response: any;
      let params = new URLSearchParams();
      params.append("token", token || "");
      params.append("SORT_BY", sortBy);
      params.append("pageSize", "all");
      params.append("pageIndex", "1");

      response = await GetStakeList(params);

      if (response?.data?.data?.stakeColl) {
        const list: Stake[] = response.data?.data?.stakeColl || [];
        setStakeList(list);
        setTotalCount(response.data.data.total_data_count || 0);

        // 🔹 STEP 1: Filter only graph nodes
        const newNodes: Node[] = list
          .filter((stake) => stake.IS_GRAPH === true)
          .map((stake) => ({
            id: String(stake.UID),
            type: "stakeholder",
            position: { x: Math.random() * 400, y: Math.random() * 400 },
            data: {
              UID: stake.UID,
              refreshStakeList: fetchStakList,
            },
          }));

        // 🔹 STEP 2: Get relation list (for edges)
        const relationList = await getStakeRelationList();

        // 🔹 STEP 3: Create edges using relation data, only if nodes exist
        const newEdges: Edge[] = relationList
          .filter(
            (rel: any) =>
              rel.PARENT_STAKE_UID &&
              newNodes.some((n) => n.id === String(rel.PARENT_STAKE_UID)) &&
              newNodes.some((n) => n.id === String(rel.STAKE_UID))
          )
          .map((rel: any) => ({
            // id: `e-${rel.PARENT_STAKE_UID}-${rel.STAKE_UID}`,
            id: `e-${rel.UID}`,
            source: String(rel.PARENT_STAKE_UID),
            target: String(rel.STAKE_UID),
            // type: "default",
            type: "deletable",
            markerEnd: { type: MarkerType.ArrowClosed },
            data: { relationUID: rel.UID, onDeleteEdge: onEdgesDelete },
          }));

        const { nodes: layoutedNodes, edges: layoutedEdges } =
          getLayoutedElements(newNodes, newEdges);

        setNodes(layoutedNodes);
        setEdges(layoutedEdges);
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchStakMapDetail = async () => {
    try {
      const params = new URLSearchParams();
      params.append("token", token || "");
      const response: any = await GetStakemapDetail(params);
      if (response?.data?.data) {
        setTitle(response?.data?.data?.TITLE || "");
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    }
  };

  const updateGraphList = async (UID: number, isGraph: boolean) => {
    try {
      await UpdateGraphList(UID, isGraph);

      // updateUserContext({
      //   ...userContext,
      //   isAlert: true,
      //   alertMessage: "Parent stakeholder updated successfully.",
      //   alertType: AlertType.Success,
      // });

      await fetchStakList(); // re-render updated hierarchy
    } catch (error: any) {
      console.error("Error updating parent:", error);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error?.message || "Failed to update parent",
        alertType: AlertType.Error,
      });
    }
  };
  const getStakeRelationList = async () => {
    try {
      let params = new URLSearchParams();
      params.append("UID", userContext?.UID.toString());
      const response: any = await GetStakeRelationList(params);

      if (response?.data) {
        //  setTemperatureTypeColl(response?.data);
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  // useEffect(() => {
  //   if (token) {
  //     fetchStakList(param.sortBy, param.pageIndex, param.pageSize);
  //     getStakeRelationList();
  //   }
  // }, [token, param.pageIndex, param.pageSize]);

  useEffect(() => {
    if (token && userContext?.UID > 0) {
      fetchStakList(param.sortBy, param.pageIndex, param.pageSize);
      getStakeRelationList();
    }
  }, [token, userContext?.UID, param.pageIndex, param.pageSize]);

  return (
    <Box sx={{ height: "85vh" }}>
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <Box sx={{ height: "100%" }}>
          <Grid container sx={{ backgroundColor: "#f9f8f5", height: "100%" }}>
            <Grid
              size={2.2}
              sx={{
                paddingTop: "10px",
                paddingRight: "16px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  minHeight: "100%",
                }}
              >
                {/* ✅ Add Button Section */}
                {isOwner && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "10px",
                      paddingTop: "10px",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="listpage-add-button"
                      onClick={() => handleOpenEditStackHolderPopup(0)}
                      sx={{
                        borderRadius: "4px !important",
                        padding: "6px 10px !important",
                        backgroundColor: "#1976d2", // optional (to highlight)
                        border: "none",
                        "&:hover": {
                          backgroundColor: "#1565c0",
                        },
                      }}
                    >
                      <Box display="flex" alignItems="center" gap="4px">
                        <AddRoundedIcon sx={{ color: "#ffffff" }} />
                        <Typography
                          className="listpage-add-button-text"
                          sx={{ color: "#ffffff", fontSize: "13px" }}
                        >
                          New stakeholder
                        </Typography>
                      </Box>
                    </Button>
                  </Box>
                )}

                {/* Top Section (80%) */}
                <Box
                  sx={{
                    // flex: "0 0 78%",
                    // flex: isOwner ? "flex" : "0 0 78%",
                    flexGrow: 1,
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    scrollbarWidth: "none",
                    "-ms-overflow-style": "none",
                  }}
                >
                  {isLoading
                    ? // Skeleton Grid (same shape as stakeholder card)
                      // Array.from({ length: 6 }).map((_, i) => (
                      //   <Box key={i} className="orgpage-grid-container">
                      //     <Paper
                      //       className="orgpage-stakeholder-paper"
                      //       sx={{
                      //         borderRadius: "6px",
                      //         p: 2,
                      //         display: "flex",
                      //         alignItems: "center",
                      //         gap: 2,
                      //       }}
                      //     >
                      //       <Skeleton variant="circular" width={40} height={40} />
                      //       <Box sx={{ flexGrow: 1 }}>
                      //         <Skeleton
                      //           variant="text"
                      //           animation="wave"
                      //           width="80%"
                      //         />
                      //         <Skeleton
                      //           variant="text"
                      //           animation="wave"
                      //           width="60%"
                      //         />
                      //       </Box>
                      //       <Skeleton variant="circular" width={24} height={24} />
                      //     </Paper>
                      //   </Box>
                      // ))
                      null
                    : filteredStakeList.map((stake) => (
                        <Box
                          key={stake.UID}
                          draggable
                          onDragStart={(e) => {
                            e.dataTransfer.setData(
                              "application/stakeholder",
                              JSON.stringify({
                                id: stake.UID,
                                name: `${stake.FIRST_NAME} ${stake.LAST_NAME}`,
                              })
                            );
                          }}
                          className="orgpage-grid-container"
                          width="100% !important"
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            width="100%"
                            gap={1}
                            className="stakeholder-hover-wrapper" // wrapper pe hover lagayenge
                          >
                            {/* Left IconButton */}
                            <IconButton
                              className="more-icon-btn"
                              sx={{
                                padding: "0 !important",
                                minWidth: "0 !important",
                                width: "auto !important",
                                height: "auto !important",
                                "& .MuiTouchRipple-root": { display: "none" },
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuClick(e, stake);
                              }}
                            >
                              <img
                                src={moreIcon}
                                alt="edit"
                                style={{ width: 16, height: 16 }}
                              />
                            </IconButton>

                            {/* Main Box */}
                            <Box
                              className="stakeholderNode-box"
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              width="100%"
                              sx={{
                                backgroundColor: "#ffffff",
                                // borderRadius: "6px",
                                cursor: "pointer",
                                p: 0,
                                minWidth: 0, // ✅ prevent flex children overflow
                              }}
                              onClick={() =>
                                handleOpenHistoryAndDetailsPopup(stake)
                              }
                            >
                              {/* LEFT CONTENT */}
                              <Box
                                sx={{ minWidth: 0, flex: 1 }} // ✅ lets text shrink inside
                                display="flex"
                                alignItems="center"
                                gap={1}
                              >
                                <Box
                                  className="stakeholderNode-color-strip"
                                  sx={{
                                    backgroundColor:
                                      stake?.COLOUR_HASH_CODE || "#C8A2C8",
                                    flexShrink: 0, // ✅ strip stays fixed
                                  }}
                                />
                                <Avatar
                                  src={stake?.PROFILE_IMAGE_BASE64 || undefined}
                                  className="stakeholderNode-avatar"
                                  sx={{
                                    flexShrink: 0,
                                    marginLeft: "15px",
                                    border: "2px solid #E0E0E0",
                                  }}
                                >
                                  {!stake?.PROFILE_IMAGE_BASE64 && (
                                    <PersonIcon />
                                  )}
                                </Avatar>

                                {/* TEXTS */}
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                  <Typography
                                    variant="body1"
                                    fontWeight={400}
                                    sx={{
                                      minWidth: 0,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      color: "rgba(35, 35, 35, 1) !important",
                                      fontSize: "14px !important",
                                      paddingRight: "4px",
                                    }}
                                  >
                                    {stake?.FIRST_NAME} {stake?.LAST_NAME}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    fontWeight={400}
                                    sx={{
                                      minWidth: 0,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      fontSize: "12px",
                                      // paddingLeft: "7px",
                                      paddingRight: "4px",
                                      color: "rgba(96, 96, 96, 1) !important",
                                    }}
                                  >
                                    {stake?.ROLE_NAME}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    fontWeight={400}
                                    sx={{
                                      minWidth: 0,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      fontSize: "12px",
                                      // paddingLeft: "7px",
                                      paddingRight: "4px",
                                      color: "rgba(96, 96, 96, 1) !important",
                                    }}
                                  >
                                    {stake?.TEAM_NAME}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    fontWeight={400}
                                    sx={{
                                      minWidth: 0,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      fontSize: "12px",
                                      // paddingLeft: "7px",
                                      paddingRight: "4px",
                                      color: "rgba(96, 96, 96, 1) !important",
                                    }}
                                  >
                                    {stake?.ORG_NAME}
                                  </Typography>
                                </Box>
                              </Box>

                              {/* ZOOM ICON */}
                              {isOwner && (
                                <IconButton
                                  className="zoom-icon-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleMenuClose();
                                    handleOpenEditStackHolderPopup(stake?.UID);
                                  }}
                                  sx={{
                                    backgroundColor: "transparent",
                                    padding: 0,
                                    flexShrink: 0,
                                    "&:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                >
                                  <img
                                    src={zoomIcon}
                                    alt="edit"
                                    style={{ width: 16, height: 16 }}
                                  />
                                </IconButton>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      ))}
                </Box>

                {/* Bottom Section (20%) */}
                {isOwner && (
                  <Box
                    sx={{
                      // flex: "0 0 16%",
                      height: "16%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      paddingLeft: "20px",
                    }}
                  >
                    {/* <Typography style={{ fontSize: "12px !important" }}>
                      Connect nodes by clicking a dot and, while holding down,
                      dragging to another (bottom dot of one node to top dot of
                      another)
                    </Typography> */}
                    <Typography style={{ fontSize: "12px !important" }}>
                      Confused? Click the question mark icon in the top right
                      corner.
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid size={9.8}>
              <ReactFlowProvider>
                <div
                  ref={flowRef}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "1px solid #eeeeee",
                    borderRadius: 8,
                    backgroundColor: "white",
                  }}
                  onDrop={isOwner ? onDrop : undefined}
                  onDragOver={isOwner ? onDragOver : undefined}
                >
                  <ReactFlow
                    nodes={nodes}
                    edges={edges}
                    nodeTypes={nodeTypes}
                    edgeTypes={edgeTypes}
                    // fitView={nodes.length > 2}
                    // defaultViewport={{ x: 0, y: 0, zoom: 1 }}
                    fitView
                    fitViewOptions={{ padding: 0.2 }}
                    minZoom={0.2}
                    maxZoom={1.2}
                    // onNodesChange={onNodesChange}
                    // onEdgesChange={onEdgesChange}
                    // onConnect={handleManualConnect}
                    // onReconnectStart={onReconnectStart}
                    // onReconnect={onReconnect}
                    // onReconnectEnd={onReconnectEnd}
                    // onEdgesDelete={onEdgesDelete}
                    // nodesDraggable={true}
                    // nodesConnectable={true}
                    onNodesChange={isOwner ? onNodesChange : undefined}
                    onEdgesChange={isOwner ? onEdgesChange : undefined}
                    onConnect={isOwner ? handleManualConnect : undefined}
                    defaultEdgeOptions={{
                      type: "smoothstep",
                      markerEnd: { type: MarkerType.ArrowClosed },
                    }}
                    onReconnectStart={isOwner ? onReconnectStart : undefined}
                    onReconnect={isOwner ? onReconnect : undefined}
                    onReconnectEnd={isOwner ? onReconnectEnd : undefined}
                    onEdgesDelete={isOwner ? onEdgesDelete : undefined}
                    nodesDraggable={isOwner}
                    nodesConnectable={isOwner}
                    snapToGrid={true}
                    snapGrid={[200, 100]}
                    deleteKeyCode={["Backspace", "Delete"]}
                    // onEdgeDoubleClick={(event, edge) => onEdgeDelete(edge)}
                    // onEdgeContextMenu={handleEdgeContextMenu}
                    onEdgeContextMenu={
                      isOwner ? handleEdgeContextMenu : undefined
                    }
                    // onNodeDragStop={handleNodeDragStop}
                  >
                    {/* <Background /> */}
                    <Background
                      variant={BackgroundVariant.Lines}
                      gap={50}
                      size={2}
                      color="#f4f4f4"
                    />
                    <Controls showInteractive={false} />
                  </ReactFlow>
                </div>
                {nodes.length === 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "55%",
                      left: "58%",
                      transform: "translate(-50%, -50%)",
                      // backgroundColor: "rgba(255, 255, 255, 0.9)",
                      // padding: "12px 20px",
                      borderRadius: 8,
                      fontSize: 14,
                      color: "black   ",
                      pointerEvents: "none",
                      // zIndex: 10,
                    }}
                  >
                    Drag nodes onto the surface and draw lines between them
                  </div>
                )}
              </ReactFlowProvider>
            </Grid>
          </Grid>
        </Box>
        {/* <Box
          sx={{
            padding: "8px 0px 18px 0px !important",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          {filteredStakeList.length > 0 && (
            <CustomPagination
              param={param}
              setParam={setParam}
              totalCount={filteredStakeList.length}
            />
          )}
        </Box> */}
      </Box>

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            minWidth: 180,
            p: 1,
          },
        }}
        MenuListProps={{
          sx: {
            p: 0,
          },
        }}
      >
        <MenuItem
          className="edit-note-menu-item"
          sx={{
            paddingLeft: 0,
            padding: 0,
            height: "28px",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleMenuClose();
            handleOpenHistoryAndDetailsPopup(selectedStakeholder);
          }}
        >
          <ListItemIcon>
            {/* <img
                src={EyeIcon}
                alt="note"
                style={{ width: 25, height: 25, color: "rgba(35, 35, 35, 1)" }}
              /> */}
            <VisibilityOutlinedIcon
              style={{
                width: 18,
                height: 18,
                marginLeft: "5px",
                color: "rgba(35, 35, 35, 1)",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Details"
            className="popup-text"
            style={{ color: "rgba(35, 35, 35, 1)" }}
          />
        </MenuItem>

        {isOwner && (
          // !!userContext?.userId &&
          <MenuItem
            className="edit-note-menu-item"
            sx={{
              paddingLeft: 0,
              padding: 0,
              height: "28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleMenuClose();
              handleOpenEditStackHolderPopup(selectedStakeholder?.UID);
            }}
          >
            <ListItemIcon>
              <img
                src={EditStakeIcon}
                alt="note"
                style={{
                  width: 25,
                  height: 25,
                  color: "rgba(35, 35, 35, 1)",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Edit"
              className="popup-text"
              style={{ color: "rgba(35, 35, 35, 1)" }}
            />
          </MenuItem>
        )}

        {/* <MenuItem
          className="edit-note-menu-item"
          sx={{
            paddingLeft: 0,
            padding: "3px 0px 3px 0px",
          }}
        >
          <ListItemIcon>
            <img
              src={DuplicateIcon}
              alt="Duplicate"
              style={{
                width: 18,
                height: 14,
                color: "rgba(35, 35, 35, 1)",
                paddingLeft: "5px",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Duplicate"
            className="popup-text"
            style={{ color: "rgba(35, 35, 35, 1)" }}
          />
        </MenuItem> */}
        {isOwner && (
          // !!userContext?.userId &&
          <MenuItem
            className="delete-note-menu-item"
            sx={{
              paddingLeft: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingRight: 0,
              height: "28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleMenuClose();
              handleDeleteStake(selectedStakeholder?.UID);
            }}
            disableRipple
          >
            <ListItemIcon className="delete-list-item-icon">
              <img
                src={DeleteImage}
                alt="delete"
                style={{ paddingLeft: "5px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              className="delete-text  popup-text"
              style={{ color: "rgba(104, 0, 1, 1)" }}
            />
          </MenuItem>
        )}
      </Menu>
      <AddNoteDialog
        UID={0}
        STAKEUID={addNotesPopup?.stakeId || ""}
        open={addNotesPopup.open}
        onClose={() => setAddNotesPopup({ open: false, stakeId: null })}
      />

      <AddStakeHolderDialog
        open={addStackHolderPopup.open}
        onClose={closeAddStakeHolderPopup}
        UID={addStackHolderPopup?.uid || 0}
        title={title}
      />

      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={undefined} // removes transition
        BackdropProps={{ transitionDuration: 0 }}
      >
        <DialogContent>
          <Typography id="alert-dialog-description">
            Are you sure you want to delete this stakeholder?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmDeleteStake}
            variant="contained"
            color="error"
            sx={{ backgroundColor: "#4C0808" }}
          >
            Yes, Delete
          </Button>
          <Button
            onClick={handleCloseDeleteModal}
            variant="outlined"
            sx={{ backgroundColor: "#ffffff" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={historyAndDetailsPopup.open}
        onClose={closeHistoryAndDetailsPopup}
        fullWidth={false}
        maxWidth={false}
        PaperProps={{
          sx: {
            // padding: "30px",
            margin: 0,
            width: "1100px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "30px 30px 16px 30px ",
          }}
        >
          <Avatar sx={{ mr: 2 }}>
            <img
              src={editProfileIcon}
              alt="Edit profile"
              style={{ width: "42px", height: "42px" }}
            />
          </Avatar>
          <Typography className="edit-popup-title">
            Stakeholder Details
          </Typography>
          <IconButton
            onClick={closeHistoryAndDetailsPopup}
            sx={{
              ml: "auto",
              padding: "0 !important",
              backgroundColor: "transparent !important",
              "&:hover": {
                backgroundColor: "transparent !important",
              },
            }}
          >
            <img
              src={CloseIcon}
              alt="Close"
              style={{ width: 24, height: 24 }}
            />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ mx: 4 }} />
        <DialogContent
          sx={{
            px: 3,
            py: 2,
            padding: "10px 0px 0px 0px",
            borderBottom: "none",
          }}
        >
          <StakeHoldersDetail
            stackholder={historyAndDetailsPopup.stake}
            handleDeleteStack={(UID: string) => {
              setDeleteStakeId(UID);
              setOpenDeleteModal(true);
            }}
          />
        </DialogContent>
      </Dialog>
      <Popover
        open={openEdgeDeletePopover}
        anchorEl={popoverAnchorEl}
        onClose={() => setOpenEdgeDeletePopover(false)}
        anchorReference="anchorPosition"
        anchorPosition={
          popoverAnchorEl
            ? {
                top: (popoverAnchorEl as any).getBoundingClientRect().top,
                left: (popoverAnchorEl as any).getBoundingClientRect().left,
              }
            : undefined
        }
      >
        <Box p={0}>
          <MenuItem
            className="delete-menu-item"
            onClick={(e) => {
              e.preventDefault();
              setOpenEdgeDeletePopover(false);
              if (selectedEdge) {
                handleEdgeContextDelete(selectedEdge);
              }
            }}
          >
            <ListItemIcon className="delete-list-item-icon">
              <DeleteIcon fontSize="small" className="delete-icon" />
            </ListItemIcon>
            <ListItemText primary="Remove link" className="delete-text" />
          </MenuItem>
        </Box>
      </Popover>
    </Box>
  );
};

export default OrgPage;
